jQuery(document).ready(function(){
   updateHoverCart();

jQuery(".mycartdrop").mouseenter(function(){  
   	jQuery("#mycartitems").css('overflow', 'visible');
  	jQuery("#mycartitems").css('overflow', 'hidden'); 
	jQuery("#cart-info").show();  
});

jQuery(".mycartdrop").mouseleave(function(){
  	jQuery("#mycartitems").css('overflow', 'hidden'); 
	jQuery("#cart-info").hide();
});
 
  
function updateHoverCart(){	
	jQuery.getJSON('/cart.js', function (cart, textStatus) {
		
		if ((typeof callback) === 'function') 
		{
		  callback(cart);		  
		}
		else 
		{		
			var item_count = cart['item_count']; 
							
			if(item_count > 0) {
				jQuery("#cart-info").remove();				
				var total_price = cart['total_price']/100; 				
				var h="<div id='cart-info'><table border='1'>";
				h+="<tr><td colspan='6' class='cart_header'>ITEMS IN YOUR CART</td></tr>"; 
              	h+="<tr><td colspan='6' id='items_container'><div id='mycartitems'><table>"; 
				var i = 1;
				jQuery.each( cart['items'], function( key, value ) {
			
					var pro_title = value['title'];
					var qty = value['quantity'];	
					var pro_url = value['url'];
					var image_url = value['image'];
					var line_price = value['line_price']/100;
					var line_count = i;
                  
                  if(i==1){ ss = 'noBorder'; }
                  else{ss = 'ss'; }
					
                  h+="<tr><td width='1%' class='"+ss+"'></td><td width='30%' class='"+ss+"'><a href='"+pro_url+"'><img src='"+image_url+"' style='width:100px;'<td>";  
					h+="<td width='50%' class='"+ss+"'><a href='"+pro_url+"' class='cart_pro_title'>"+pro_title+"</a><br/><a class='cart_remove' href='/cart/change?line="+line_count+"&quantity=0'>REMOVE</a></td>";
					h+="<td width='8%' class='"+ss+"'>"+qty+"</td><td width='11%' class='"+ss+"'>&#36;"+line_price.toFixed(2);+"</td></tr>";
					
					i++;	
				});				
				//h+="<tr><td></td><td></td><td class='cart_subtotal'>SUBTOTAL</td><td></td><td><strong>&#36;"+total_price.toFixed(2)+"</strong></td><td></td></tr>";
				h+="</table></div></td></tr>";	
              
              h+="<tr><td colspan='6' id='items_container1'><div id='mycartitems1'><table>";              
              h+="<tr><td width='50%' class='cart_subtotal'>SUBTOTAL</td><td width='11%'><strong>&#36;"+total_price.toFixed(2)+"</strong></td></tr>";
              h+="</table></div></td></tr>";             
              
              
				h+="<tr><td colspan='6' style='text-align:center' id='cart_buttons_td'><div id='view_cart'><a href=\"/cart\">VIEW CART</a></div><div id='checkout_me'><a href=\"/checkout\">CHECKOUT</a></div></td></tr>";
				h+="</table></div>"; 
								
				jQuery(".mycartdrop").append(h);
				jQuery("#cart-info").hide();
              	
              	// update the cart icon
  				jQuery('.mycartdrop #cart').addClass('added');
              	jQuery('#cart-count').removeClass('hidden').text(cart['item_count']);
			}		
		  //Shopify.onCartUpdate(cart);
		} 
	});
}
  
   function addItem(form_id) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#'+form_id).serialize(),
        success: Shopify.onSuccess,
        error: Shopify.onError
      });
   }

   $(".addtocart").click(function(e){   
      var elem = $(this)
      $(elem).prop("disabled", true)
      e.preventDefault();
      addItem('add-item-form');
      setTimeout(function(){updateHoverCart();},1000);  
   });
  
   Shopify.onSuccess = function() {     
        var elem = $('.addtocart');  
     	var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;
        elem.removeAttr("disabled");
        var cartCount =  parseInt($('#cart-count').text()) + quantity;     
        $('#cart-count a').text(' ' + cartCount + " items");         
     	window.scrollTo(1000, 0);
     	setTimeout(function() {
          
          	setTimeout(function(){jQuery("#mycartitems").niceScroll({touchbehavior:false,cursorcolor:"#bfa378",cursoropacitymax:0.7,cursorwidth:6,background:"#dbcdb1",autohidemode:false}); },1000);
       		jQuery("#mycartitems").css('overflow', 'visible');
  			jQuery("#mycartitems").css('overflow', 'hidden');          
            jQuery("#cart-info").show(); 
       		 }, 1000);
     
     	setTimeout(function() {
          jQuery("#mycartitems").css('overflow', 'hidden');
              jQuery("#cart-info").hide();      
       		 }, 10000);
           
    };
    
    setTimeout(function(){jQuery("#mycartitems").niceScroll({touchbehavior:false,cursorcolor:"#bfa378",cursoropacitymax:0.7,cursorwidth:6,background:"#dbcdb1",autohidemode:false}); },1000);
    
    Shopify.onError = function(XMLHttpRequest, textStatus) {
      // Shopify returns a description of the error in XMLHttpRequest.responseText.
      // It is JSON.
      // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
      } else {
        alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
      }

      $('.addtocart').removeAttr("disabled");
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };

});